// @ts-nocheck


import Button from 'antd/lib/button';


import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { DatePicker } from '../../../components/ant/DatePicker';

import { Form, Selects } from './../../../components';
import CancelButton from './../../../components/CancelButton';

import { Footer, Section } from './../../../components/layout';
import Grid, { GridItem } from './../../../components/layout/Grid';

const {
  MaintenanceWorkTypeSelect,
  OrderContractorTypeSelect,
  ExpenseDirectionTreeSelect,
  RepairePlanSelect
} = Selects;

const SectionContent = styled.div.withConfig({ displayName: "InnerForm__SectionContent", componentId: "sc-7mzel9-0" })(["padding:16px;"]);









export default ({ compareExpenseDirection, onSubmit, onCancel }) => {
  return (
    <Form initialValues={compareExpenseDirection} onSubmit={onSubmit}>
      {(FormField, formikProps) => {
        const { handleSubmit, dirty, setFieldValue, values } = formikProps;
        return (
          <form onSubmit={handleSubmit}>
            <Section>
              <SectionContent>
                <Grid gutter="16px">
                  <GridItem>
                    <FormField
                      label="Вид работ"
                      name="maintenanceWorkTypeId"
                      required
                      fast>

                      {({ value, name }) =>
                      <MaintenanceWorkTypeSelect
                        value={value}
                        onChange={(id) => setFieldValue(name, id)} />

                      }
                    </FormField>
                  </GridItem>
                  <GridItem>
                    <FormField
                      label="Способ выполнения"
                      name="orderContractor"
                      required
                      fast>

                      {({ value, name }) =>
                      <OrderContractorTypeSelect
                        value={value}
                        onChange={(type) => setFieldValue(name, type)} />

                      }
                    </FormField>
                  </GridItem>
                  <GridItem>
                    <FormField
                      label="График работ"
                      required
                      fast
                      name="repairPlan">

                      {({ value, name }) =>
                      <RepairePlanSelect
                        value={value}
                        onChange={(type) => setFieldValue(name, type)} />

                      }
                    </FormField>
                  </GridItem>
                  <GridItem>
                    <FormField
                      label="Наименование расхода"
                      name="expenseDirectionId"
                      required
                      fast>

                      {({ value, name }) =>
                      <ExpenseDirectionTreeSelect
                        value={value}
                        onChange={(type) => setFieldValue(name, type)} />

                      }
                    </FormField>
                  </GridItem>
                </Grid>
                <Grid gutter="16px">
                  <GridItem>
                    <FormField label="Дата начала" name="startDate" required>
                      {({ name, value }) =>
                      <DatePicker
                        name={name}
                        value={value ? moment(value) : value}
                        format="DD MMMM YYYY"
                        onChange={(value) => {
                          setFieldValue(
                            name,
                            moment.utc(value).startOf('day').toISOString()
                          );
                          setFieldValue('endDate', undefined);
                        }} />

                      }
                    </FormField>
                  </GridItem>
                  <GridItem>
                    <FormField label="Дата окончания" name="endDate">
                      {({ name, value }) =>
                      <DatePicker
                        name={name}
                        value={value ? moment(value) : value}
                        format="DD MMMM YYYY"
                        disabled={values.startDate ? false : true}
                        disabledDate={(date) =>
                        values.startDate ?
                        moment.
                        utc(date).
                        startOf('day').
                        isSameOrBefore(moment.utc(values.startDate)) :
                        false
                        }
                        onChange={(value) =>
                        setFieldValue(
                          name,
                          moment.utc(value).startOf('day').toISOString()
                        )
                        } />

                      }
                    </FormField>
                  </GridItem>
                </Grid>
              </SectionContent>
            </Section>
            <Footer>
              <Button type="primary" htmlType="submit" data-cy="save">
                Сохранить
              </Button>
              <CancelButton dirty={dirty} onClick={onCancel}>
                Отменить
              </CancelButton>
            </Footer>
          </form>);

      }}
    </Form>);

};
